import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const resourceTypesSlice = createSlice({
  name: "resourceTypes",
  initialState: [],
  reducers: {
    setTaskResourceType: (_state: any, action: PayloadAction<any>) => ({
      ..._state,
      ...action.payload,
    }),
  },
});

const resourcesSlice = createSlice({
  name: "resources",
  initialState: [],
  reducers: {
    setTaskResource: (_state: any, action: PayloadAction<any>) => action.payload,
  },
});

const resourceCreatedSlice = createSlice({
  name: "resourceCreated",
  initialState: false,
  reducers: {
    setResourceCreated: (_state: any, action: PayloadAction<any>) => action.payload,
  },
});

export const { setTaskResourceType } = resourceTypesSlice.actions;
export const { setTaskResource } = resourcesSlice.actions;
export const { setResourceCreated } = resourceCreatedSlice.actions;

export const resourceTypes = resourceTypesSlice.reducer;
export const resources = resourcesSlice.reducer;
export const resourceCreated = resourceCreatedSlice.reducer;

export default {
  resourceTypes,
  resources,
  resourceCreated,
};
